/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Metric_HeaviestInputs */

const en_us2_exercise_sheet_metric_heaviest = /** @type {(inputs: Exercise_Sheet_Metric_HeaviestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heaviest`)
};

const pt_br2_exercise_sheet_metric_heaviest = /** @type {(inputs: Exercise_Sheet_Metric_HeaviestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior peso`)
};

const es_419_exercise_sheet_metric_heaviest = /** @type {(inputs: Exercise_Sheet_Metric_HeaviestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor peso`)
};

const pt_pt2_exercise_sheet_metric_heaviest = /** @type {(inputs: Exercise_Sheet_Metric_HeaviestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior peso`)
};

const fr_fr2_exercise_sheet_metric_heaviest = /** @type {(inputs: Exercise_Sheet_Metric_HeaviestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge max`)
};

const de_de2_exercise_sheet_metric_heaviest = /** @type {(inputs: Exercise_Sheet_Metric_HeaviestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstes`)
};

const it_it2_exercise_sheet_metric_heaviest = /** @type {(inputs: Exercise_Sheet_Metric_HeaviestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso max`)
};

/**
* | output |
* | --- |
* | "Heaviest" |
*
* @param {Exercise_Sheet_Metric_HeaviestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_metric_heaviest = /** @type {((inputs?: Exercise_Sheet_Metric_HeaviestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Metric_HeaviestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_metric_heaviest(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_metric_heaviest(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_metric_heaviest(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_metric_heaviest(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_metric_heaviest(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_metric_heaviest(inputs)
	return en_us2_exercise_sheet_metric_heaviest(inputs)
});
export { exercise_sheet_metric_heaviest as "exercise-sheet.metric_heaviest" }